<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="partone"><a id="page_1"></a><span class="small">PART ONE</span><br/><strong>GANGS: NOW &amp; THEN</strong><a id="page_2"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01_partone.vue?650b7f75